"use strict";

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e.default : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var _partial = _interopDefault(require("ramda/src/partial")),
    _curry = _interopDefault(require("ramda/src/curry")),
    _pipeP = _interopDefault(require("ramda/src/pipeP")),
    _keys = _interopDefault(require("ramda/src/keys")),
    _forEach = _interopDefault(require("ramda/src/forEach")),
    _dissoc = _interopDefault(require("ramda/src/dissoc")),
    _merge = _interopDefault(require("ramda/src/merge")),
    _prop = _interopDefault(require("ramda/src/prop")),
    _always = _interopDefault(require("ramda/src/always")),
    _ifElse = _interopDefault(require("ramda/src/ifElse")),
    _contains = _interopDefault(require("ramda/src/contains")),
    _gte = _interopDefault(require("ramda/src/gte")),
    _curryN = _interopDefault(require("ramda/src/curryN")),
    _T = _interopDefault(require("ramda/src/T")),
    _is = _interopDefault(require("ramda/src/is")),
    _identity = _interopDefault(require("ramda/src/identity")),
    _isNil = _interopDefault(require("ramda/src/isNil")),
    _cond = _interopDefault(require("ramda/src/cond")),
    axios = _interopDefault(require("axios")),
    _assign = function __assign() {
  return (_assign = Object.assign || function (e) {
    for (var r, t = 1, n = arguments.length; t < n; t++) {
      for (var a in r = arguments[t]) {
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    __awaiter = function __awaiter(e, r, t, n) {
  return new (t || (t = Promise))(function (a, i) {
    function s(e) {
      try {
        u(n.next(e));
      } catch (e) {
        i(e);
      }
    }

    function o(e) {
      try {
        u(n.throw(e));
      } catch (e) {
        i(e);
      }
    }

    function u(e) {
      e.done ? a(e.value) : new t(function (r) {
        r(e.value);
      }).then(s, o);
    }

    u((n = n.apply(e, r || [])).next());
  });
},
    __generator = function __generator(e, r) {
  var t,
      n,
      a,
      i,
      s = {
    label: 0,
    sent: function sent() {
      if (1 & a[0]) throw a[1];
      return a[1];
    },
    trys: [],
    ops: []
  };
  return i = {
    next: o(0),
    throw: o(1),
    return: o(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;

  function o(i) {
    return function (o) {
      return function (i) {
        if (t) throw new TypeError("Generator is already executing.");

        for (; s;) {
          try {
            if (t = 1, n && (a = 2 & i[0] ? n.return : i[0] ? n.throw || ((a = n.return) && a.call(n), 0) : n.next) && !(a = a.call(n, i[1])).done) return a;

            switch (n = 0, a && (i = [2 & i[0], a.value]), i[0]) {
              case 0:
              case 1:
                a = i;
                break;

              case 4:
                return s.label++, {
                  value: i[1],
                  done: !1
                };

              case 5:
                s.label++, n = i[1], i = [0];
                continue;

              case 7:
                i = s.ops.pop(), s.trys.pop();
                continue;

              default:
                if (!(a = (a = s.trys).length > 0 && a[a.length - 1]) && (6 === i[0] || 2 === i[0])) {
                  s = 0;
                  continue;
                }

                if (3 === i[0] && (!a || i[1] > a[0] && i[1] < a[3])) {
                  s.label = i[1];
                  break;
                }

                if (6 === i[0] && s.label < a[1]) {
                  s.label = a[1], a = i;
                  break;
                }

                if (a && s.label < a[2]) {
                  s.label = a[2], s.ops.push(i);
                  break;
                }

                a[2] && s.ops.pop(), s.trys.pop();
                continue;
            }

            i = r.call(e, s);
          } catch (e) {
            i = [6, e], n = 0;
          } finally {
            t = a = 0;
          }
        }

        if (5 & i[0]) throw i[1];
        return {
          value: i[0] ? i[1] : void 0,
          done: !0
        };
      }([i, o]);
    };
  }
},
    _this = void 0,
    toNumber = _cond([[_isNil, _identity], [_is(Number), _identity], [_T, function (e) {
  return Number(e);
}]]),
    isWithin = _curryN(3, function (e, r, t) {
  var n = _is(Number);

  return n(e) && n(r) && n(t) && _gte(t, e) && _gte(r, t);
}),
    containsText = _curryN(2, function (e, r) {
  return _contains(r, e);
}),
    isPromise = function isPromise(e) {
  return !!e && ("object" == typeof e || "function" == typeof e) && "function" == typeof e.then;
},
    DEFAULT_HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json"
},
    DEFAULT_CONFIG = {
  timeout: 0
},
    NONE = null,
    CLIENT_ERROR = "CLIENT_ERROR",
    SERVER_ERROR = "SERVER_ERROR",
    TIMEOUT_ERROR = "TIMEOUT_ERROR",
    CONNECTION_ERROR = "CONNECTION_ERROR",
    NETWORK_ERROR = "NETWORK_ERROR",
    UNKNOWN_ERROR = "UNKNOWN_ERROR",
    CANCEL_ERROR = "CANCEL_ERROR",
    TIMEOUT_ERROR_CODES = ["ECONNABORTED"],
    NODEJS_CONNECTION_ERROR_CODES = ["ENOTFOUND", "ECONNREFUSED", "ECONNRESET"],
    in200s = isWithin(200, 299),
    in400s = isWithin(400, 499),
    in500s = isWithin(500, 599),
    statusNil = _ifElse(_isNil, _always(void 0), _prop("status")),
    getProblemFromError = function getProblemFromError(e) {
  return "Network Error" === e.message ? NETWORK_ERROR : axios.isCancel(e) ? CANCEL_ERROR : _cond([[_isNil, function () {
    return getProblemFromStatus(statusNil(e.response));
  }], [containsText(TIMEOUT_ERROR_CODES), _always(TIMEOUT_ERROR)], [containsText(NODEJS_CONNECTION_ERROR_CODES), _always(CONNECTION_ERROR)], [_T, _always(UNKNOWN_ERROR)]])(e.code);
},
    getProblemFromStatus = function getProblemFromStatus(e) {
  return _cond([[_isNil, _always(UNKNOWN_ERROR)], [in200s, _always(NONE)], [in400s, _always(CLIENT_ERROR)], [in500s, _always(SERVER_ERROR)], [_T, _always(UNKNOWN_ERROR)]])(e);
},
    create = function create(e) {
  var r,
      t = _merge(DEFAULT_HEADERS, e.headers || {});

  if (e.axiosInstance) r = e.axiosInstance;else {
    var n = _merge(DEFAULT_CONFIG, _dissoc("headers", e));

    r = axios.create(n);
  }

  var a = [],
      i = [],
      s = [],
      o = [],
      u = [],
      R = function R(e, n) {
    return t[e] = n, r;
  },
      c = function c(e, r, t, n) {
    return void 0 === t && (t = {}), void 0 === n && (n = {}), l(_merge({
      url: r,
      params: t,
      method: e
    }, n));
  },
      _ = function _(e, r, t, n) {
    return void 0 === t && (t = null), void 0 === n && (n = {}), l(_merge({
      url: r,
      method: e,
      data: t
    }, n));
  },
      l = function l(e) {
    return __awaiter(_this, void 0, void 0, function () {
      var n, a, o;
      return __generator(this, function (u) {
        switch (u.label) {
          case 0:
            if (e.headers = _assign({}, t, e.headers), i.length > 0 && _forEach(function (r) {
              return r(e);
            }, i), !(s.length > 0)) return [3, 6];
            n = 0, u.label = 1;

          case 1:
            return n < s.length ? (a = s[n](e), isPromise(a) ? [4, a] : [3, 3]) : [3, 6];

          case 2:
            return u.sent(), [3, 5];

          case 3:
            return [4, a(e)];

          case 4:
            u.sent(), u.label = 5;

          case 5:
            return n++, [3, 1];

          case 6:
            return o = _pipeP(O(toNumber(new Date())), E), [2, r.request(e).then(o).catch(o)];
        }
      });
    });
  },
      E = function E(e) {
    return a.forEach(function (r) {
      try {
        r(e);
      } catch (e) {}
    }), e;
  },
      O = _curry(function (e, r) {
    return __awaiter(_this, void 0, void 0, function () {
      var t, n, a, i, s, R, c, _, l, E, O, f, N, p, d, T;

      return __generator(this, function (m) {
        switch (m.label) {
          case 0:
            if (t = toNumber(new Date()), n = t - e, a = r instanceof Error || axios.isCancel(r), i = r, s = r, R = a ? s.response : i, c = R && R.status || null, _ = a ? getProblemFromError(r) : getProblemFromStatus(c), l = a ? s : null, E = in200s(c), O = r.config || null, f = R && R.headers || null, N = R && R.data || null, p = {
              duration: n,
              problem: _,
              originalError: l,
              ok: E,
              status: c,
              headers: f,
              config: O,
              data: N
            }, o.length > 0 && _forEach(function (e) {
              return e(p);
            }, o), !(u.length > 0)) return [3, 6];
            d = 0, m.label = 1;

          case 1:
            return d < u.length ? (T = u[d](p), isPromise(T) ? [4, T] : [3, 3]) : [3, 6];

          case 2:
            return m.sent(), [3, 5];

          case 3:
            return [4, T(p)];

          case 4:
            m.sent(), m.label = 5;

          case 5:
            return d++, [3, 1];

          case 6:
            return [2, p];
        }
      });
    });
  });

  return {
    axiosInstance: r,
    monitors: a,
    addMonitor: function addMonitor(e) {
      a.push(e);
    },
    requestTransforms: i,
    asyncRequestTransforms: s,
    responseTransforms: o,
    asyncResponseTransforms: u,
    addRequestTransform: function addRequestTransform(e) {
      return i.push(e);
    },
    addAsyncRequestTransform: function addAsyncRequestTransform(e) {
      return s.push(e);
    },
    addResponseTransform: function addResponseTransform(e) {
      return o.push(e);
    },
    addAsyncResponseTransform: function addAsyncResponseTransform(e) {
      return u.push(e);
    },
    setHeader: R,
    setHeaders: function setHeaders(e) {
      return _forEach(function (r) {
        return R(r, e[r]);
      }, _keys(e)), r;
    },
    deleteHeader: function deleteHeader(e) {
      return delete t[e], r;
    },
    headers: t,
    setBaseURL: function setBaseURL(e) {
      return r.defaults.baseURL = e, r;
    },
    getBaseURL: function getBaseURL() {
      return r.defaults.baseURL;
    },
    get: _partial(c, ["get"]),
    delete: _partial(c, ["delete"]),
    head: _partial(c, ["head"]),
    post: _partial(_, ["post"]),
    put: _partial(_, ["put"]),
    patch: _partial(_, ["patch"]),
    link: _partial(c, ["link"]),
    unlink: _partial(c, ["unlink"])
  };
},
    isCancel = axios.isCancel,
    CancelToken = axios.CancelToken,
    apisauce = {
  DEFAULT_HEADERS: DEFAULT_HEADERS,
  NONE: NONE,
  CLIENT_ERROR: CLIENT_ERROR,
  SERVER_ERROR: SERVER_ERROR,
  TIMEOUT_ERROR: TIMEOUT_ERROR,
  CONNECTION_ERROR: CONNECTION_ERROR,
  NETWORK_ERROR: NETWORK_ERROR,
  UNKNOWN_ERROR: UNKNOWN_ERROR,
  create: create,
  isCancel: isCancel,
  CancelToken: CancelToken
};

exports.DEFAULT_HEADERS = DEFAULT_HEADERS, exports.NONE = NONE, exports.CLIENT_ERROR = CLIENT_ERROR, exports.SERVER_ERROR = SERVER_ERROR, exports.TIMEOUT_ERROR = TIMEOUT_ERROR, exports.CONNECTION_ERROR = CONNECTION_ERROR, exports.NETWORK_ERROR = NETWORK_ERROR, exports.UNKNOWN_ERROR = UNKNOWN_ERROR, exports.CANCEL_ERROR = CANCEL_ERROR, exports.getProblemFromError = getProblemFromError, exports.getProblemFromStatus = getProblemFromStatus, exports.create = create, exports.isCancel = isCancel, exports.CancelToken = CancelToken, exports.default = apisauce;